import styles from './SideNav.module.css';

import BuyEveryCTA from './components/BuyEveryCTA/BuyEveryCTA';
import SearchButton from './components/SearchButton/SearchButton';

import ds from '@/styles/ds/ds.module.scss';

import BottomCollapseButton from './components/BottomCollapseButton/BottomCollapseButton';
import CasinoCategories from './components/CasinoCategories/CasinoCategories';
import LiveSupport from './components/LiveSupportButton/LiveSupportButton';
import SectionDivider from './components/SectionDivider/SectionDivider';
import SectionTitle from './components/SectionTitle/SectionTitle';
import SideNavItem from './components/SideNavItem/SideNavItem';
import TopExpandButton from './components/TopExpandButton/TopExpandButton';
import { data, otherData, vipData } from './data/index';
import OfferLinks from './data/OfferLinks/OfferLinks';
import ProfileLinks from './data/ProfileLinks/ProfileLinks';

const SideNav = () => {
	return (
		<div
			id="sidenav"
			className={`${styles.sidebar} 
		`}
			data-sidenavopen="true"
		>
			<div
				className={`overflow-y-auto overflow-x-hidden h-full ${ds.scrollbar_thin} `}
			>
				<TopExpandButton />
				<SearchButton />
				<div className="min-w-[205px] ">
					<BuyEveryCTA />

					<SectionDivider hideOnMobile={true} />

					<SectionWrapper>
						{data.map((item, index) => {
							return <SideNavItem key={index} {...item} />;
						})}
					</SectionWrapper>
					<SectionDivider />
					<SectionWrapper>
						<CasinoCategories />
					</SectionWrapper>

					{/* <SectionWrapper>
						<SectionTitle title="Casino" />

						{casinoData.map((item, index) => {
							return <SideNavItem key={index} {...item} />;
						})}
					</SectionWrapper> */}
					<SectionDivider />
					{/* <SectionWrapper>
						<SectionTitle title="Offers" />

						{offersData.map((item, index) => {
							return <SideNavItem key={index} {...item} />;
						})}
					</SectionWrapper> */}
					<OfferLinks />
					<SectionDivider />
					<SectionWrapper>
						<SectionTitle title="VIP" />

						{vipData.map((item, index) => {
							return <SideNavItem key={index} {...item} />;
						})}
					</SectionWrapper>
					<SectionDivider />
					{/* <SectionWrapper>
						<SectionTitle title="Profile" />
						{profileData.map((item, index) => {
							return <SideNavItem key={index} {...item} />;
						})}
					</SectionWrapper> */}
					<ProfileLinks />
					<SectionDivider />
					<SectionWrapper>
						<SectionTitle title="Other" />
						{otherData.map((item, index) => {
							return <SideNavItem key={index} {...item} />;
						})}
						<LiveSupport />
					</SectionWrapper>
				</div>

				<BottomCollapseButton />
			</div>
		</div>
	);
};

export default SideNav;

export const SectionWrapper = ({ children }) => {
	return <section className="flex flex-col   px-2.5  ">{children}</section>;
};
